// src/components/CallRequestModal.jsx
import React from 'react';
import styled from 'styled-components';

const Back = styled.div`
  position:fixed; inset:0; background:rgba(0,0,0,.45); display:grid; place-items:center; z-index:1000;
`;
const Box = styled.form`
  width:min(540px, 92vw); border-radius:16px; border:1px solid var(--bdr); background:var(--card); box-shadow:0 24px 60px rgba(0,0,0,.3);
  padding:18px;
  h3{ margin:0 0 8px; }
  .row{ display:grid; gap:10px; grid-template-columns:1fr 1fr; }
  input, textarea{ padding:12px 14px; border-radius:14px; border:1px solid var(--bdr); background:var(--card); color:inherit; }
  textarea{ min-height:110px; resize:vertical; }
  .actions{ display:flex; gap:10px; justify-content:flex-end; margin-top:12px; }
`;

export default function CallRequestModal({ open, onClose, objectTitle }) {
  const [data, set] = React.useState({ name:'', phone:'', email:'', msg:`Хочу обсудить: ${objectTitle || ''}` });
  const [ok, setOk] = React.useState('');
  const [err, setErr] = React.useState('');

  if(!open) return null;

  const mask = (v) =>
    v.replace(/[^\d+]/g, '')
     .replace(/^(\+7|8)?(\d{0,10}).*$/, (_, p2)=>'+7'+(p2||'').padEnd(10,'_'));

  const change = e => { const {name,value} = e.target; set(s=>({...s,[name]: name==='phone'?mask(value):value})); setErr(''); setOk(''); };
  const submit = e => {
    e.preventDefault();
    if(!data.name || !/^\+7\d{10}$/.test(data.phone.replace(/_/g,''))) { setErr('Укажите имя и корректный телефон в формате +7XXXXXXXXXX'); return; }
    setOk('Заявка отправлена. Мы свяжемся с вами в ближайшее время.');
    // тут можно отправить на API
    setTimeout(()=> onClose?.(), 1500);
  };

  return (
    <Back onClick={onClose}>
      <Box onSubmit={submit} onClick={e=>e.stopPropagation()}>
        <h3>Заказать звонок</h3>
        <div style={{color:'var(--muted)', marginBottom:10}}>{objectTitle}</div>
        <div className="row">
          <input name="name" placeholder="Имя" value={data.name} onChange={change}/>
          <input name="phone" placeholder="+7XXXXXXXXXX" value={data.phone} onChange={change}/>
        </div>
        <input name="email" placeholder="E-mail" value={data.email} onChange={change}/>
        <textarea name="msg" value={data.msg} onChange={change}/>
        {err && <div style={{color:'#e44747', fontSize:13}}>{err}</div>}
        {ok && <div style={{color:'#2f9e44', fontSize:13}}>{ok}</div>}
        <div className="actions">
          <button type="button" className="btn" onClick={onClose}>Отмена</button>
          <button type="submit" className="btn-primary">Отправить</button>
        </div>
      </Box>
    </Back>
  );
}
